import { render } from "./section3.vue?vue&type=template&id=034369fa&scoped=true"
import script from "./section3.vue?vue&type=script&lang=js"
export * from "./section3.vue?vue&type=script&lang=js"

import "./section3.vue?vue&type=style&index=0&id=034369fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034369fa"]])

export default __exports__